import React from 'react';
import { Activity, Heart, Scale, Thermometer, Brain } from 'lucide-react';

const Biometrics = () => {
  return (
    <div className="p-6">
      <div className="flex items-center mb-6">
        <div className="w-10 h-10 rounded-full bg-brand-100 flex items-center justify-center text-brand-600 mr-3">
          <Activity size={20} />
        </div>
        <div>
          <h1 className="text-2xl font-bold text-gray-900">Biometrics</h1>
          <p className="text-gray-600">Track and monitor patient biometric data</p>
        </div>
      </div>

      {/* Summary Cards */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-6">
        <div className="bg-white rounded-lg shadow-sm p-6">
          <div className="flex items-center justify-between mb-4">
            <h3 className="text-sm font-medium text-gray-500">Heart Rate</h3>
            <Heart className="text-brand-600" size={20} />
          </div>
          <p className="text-2xl font-bold text-gray-900">72 bpm</p>
          <p className="text-sm text-green-600 mt-2">Within normal range</p>
        </div>

        <div className="bg-white rounded-lg shadow-sm p-6">
          <div className="flex items-center justify-between mb-4">
            <h3 className="text-sm font-medium text-gray-500">Weight</h3>
            <Scale className="text-brand-600" size={20} />
          </div>
          <p className="text-2xl font-bold text-gray-900">45 kg</p>
          <p className="text-sm text-green-600 mt-2">Last updated: 2 days ago</p>
        </div>

        <div className="bg-white rounded-lg shadow-sm p-6">
          <div className="flex items-center justify-between mb-4">
            <h3 className="text-sm font-medium text-gray-500">Temperature</h3>
            <Thermometer className="text-brand-600" size={20} />
          </div>
          <p className="text-2xl font-bold text-gray-900">37.2°C</p>
          <p className="text-sm text-green-600 mt-2">Normal</p>
        </div>

        <div className="bg-white rounded-lg shadow-sm p-6">
          <div className="flex items-center justify-between mb-4">
            <h3 className="text-sm font-medium text-gray-500">Sleep Quality</h3>
            <Brain className="text-brand-600" size={20} />
          </div>
          <p className="text-2xl font-bold text-gray-900">85%</p>
          <p className="text-sm text-green-600 mt-2">Good</p>
        </div>
      </div>

      {/* Detailed Data Section */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        <div className="bg-white rounded-lg shadow-sm p-6">
          <h3 className="text-lg font-medium text-gray-900 mb-4">Vital Signs History</h3>
          <div className="h-64 bg-gray-50 rounded-lg flex items-center justify-center">
            <p className="text-gray-500">Chart placeholder - Vital signs history will be displayed here</p>
          </div>
        </div>

        <div className="bg-white rounded-lg shadow-sm p-6">
          <h3 className="text-lg font-medium text-gray-900 mb-4">Sleep Patterns</h3>
          <div className="h-64 bg-gray-50 rounded-lg flex items-center justify-center">
            <p className="text-gray-500">Chart placeholder - Sleep patterns will be displayed here</p>
          </div>
        </div>

        <div className="bg-white rounded-lg shadow-sm p-6">
          <h3 className="text-lg font-medium text-gray-900 mb-4">Activity Levels</h3>
          <div className="h-64 bg-gray-50 rounded-lg flex items-center justify-center">
            <p className="text-gray-500">Chart placeholder - Activity levels will be displayed here</p>
          </div>
        </div>

        <div className="bg-white rounded-lg shadow-sm p-6">
          <h3 className="text-lg font-medium text-gray-900 mb-4">Growth Tracking</h3>
          <div className="h-64 bg-gray-50 rounded-lg flex items-center justify-center">
            <p className="text-gray-500">Chart placeholder - Growth tracking data will be displayed here</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Biometrics; 